import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useDescribeState } from '../../describe-stage/context/DescribeStateContext';
import { useDebriefFactsState } from '../../shared/context/DebriefFactsStateContext';
import { useDeepDiveState } from '../context/DeepDiveStateContext';
import { DeepDiveChat } from './DeepDiveChat';
import './deepDive.css';

interface DeepDivePageProps {
  sessionId: string;
}

export function DeepDivePage({ sessionId }: DeepDivePageProps) {
  const navigate = useNavigate();
  const { state: describeState } = useDescribeState();
  const { facts, isLoading: isFactsLoading } = useDebriefFactsState();
  const { state: deepDiveState } = useDeepDiveState();

  useEffect(() => {
    if (!describeState.isComplete) {
      navigate({
        to: '/interactions/debrief-v2/$id/describe',
        params: { id: sessionId },
        replace: true,
      });
      return;
    }
    if (!isFactsLoading && facts.length === 0) {
      navigate({
        to: '/interactions/debrief-v2/$id/gather',
        params: { id: sessionId },
        replace: true,
      });
      return;
    }
    if (!isFactsLoading && deepDiveState.matchPoints.length === 0) {
      navigate({
        to: '/interactions/debrief-v2/$id/match-points',
        params: { id: sessionId },
        replace: true,
      });
      return;
    }
    if (deepDiveState.isComplete) {
      navigate({
        to: '/interactions/debrief-v2/$id/lessons',
        params: { id: sessionId },
        replace: true,
      });
    }
  }, [
    describeState.isComplete,
    isFactsLoading,
    facts.length,
    deepDiveState.matchPoints.length,
    deepDiveState.isComplete,
    navigate,
    sessionId,
  ]);

  if (
    !describeState.isComplete ||
    isFactsLoading ||
    deepDiveState.matchPoints.length === 0
  ) {
    return (
      <main className="flex-1 w-full max-w-[760px] mx-auto pt-8 pb-24 px-6" />
    );
  }

  return (
    <main className="flex-1 w-full max-w-[760px] mx-auto pt-8 pb-24 px-6">
      <DeepDiveChat />
    </main>
  );
}
